/**
 * Status values for InventorySnapshotStockOrderTask (parent task).
 * Must match backend korona.models.InventorySnapshotStockOrderTaskStatus.
 */
export enum SnapshotTaskStatus {
    PENDING = 'PENDING',
    STARTED = 'STARTED',
    PROGRESS = 'PROGRESS',
    SUCCESS = 'SUCCESS',
    FAILURE = 'FAILURE',
    PARTIAL_SUCCESS = 'PARTIAL_SUCCESS',
}

/**
 * Status values for InventorySnapshotStockOrderTaskItem.
 * Must match backend korona.models.InventorySnapshotStockOrderTaskItemStatus.
 */
export enum SnapshotTaskItemStatus {
    PENDING = 'PENDING',
    SUCCESS = 'SUCCESS',
    FAILURE = 'FAILURE',
}

/** Dropdown options for filtering task items by status */
export const SNAPSHOT_TASK_ITEM_STATUS_OPTIONS: { value: string; label: string }[] = [
    { value: '', label: 'All' },
    { value: SnapshotTaskItemStatus.PENDING, label: 'Pending' },
    { value: SnapshotTaskItemStatus.SUCCESS, label: 'Success' },
    { value: SnapshotTaskItemStatus.FAILURE, label: 'Failure' },
];
